import { Box, Stack } from '@mui/material';
import {
  FirstPaginationNode,
  GetBindPageQuery,
  SubmissionType,
} from '@converge/graphql';

import { Address } from './address';

import { formatDollarAmount } from '@converge/utils';
import { useUnderwritingSubmissionStateContext } from './underwriting.submission.context';
import './underwriting.bind-or-policy.header.scss';
interface IUnderwritingBindOrPolicyHeaderProps {
  quote?: FirstPaginationNode<GetBindPageQuery['quotes']>;
}

export const UnderwritingBindOrPolicyHeader = ({
  quote,
}: IUnderwritingBindOrPolicyHeaderProps) => {
  const {
    info: {
      brokerAddress,
      brokerAgentEmailAddress,
      brokerAgentName,
      brokerEntityName,
      insuredAlias,
      insuredAddress,
      submissionType,
    },
  } = useUnderwritingSubmissionStateContext();
  return (
    <Stack flexDirection={'row'} gap={2}>
      <Box flexGrow={1}>
        <Box
          className="header-binder-policy-main-title"
          style={{ width: '240px' }}
        >
          Brokerage and Broker
        </Box>
        <p>
          <Box className="header-binder-policy-main-subtitle">
            {brokerAgentName}
          </Box>
          <Box className="header-binder-policy-content">
            {brokerAgentEmailAddress ? (
              <a
                href={`mailto:${brokerAgentEmailAddress}`}
                style={{
                  color: 'initial',
                  textDecoration: 'none',
                }}
              >
                {brokerAgentEmailAddress}
              </a>
            ) : (
              'Email N/A'
            )}
          </Box>
        </p>

        <p>
          <Box className="header-binder-policy-main-subtitle">
            {brokerEntityName}
          </Box>
          <Box
            className="header-binder-policy-content"
            style={{ marginBottom: '60px' }}
          >
            {brokerAddress ? <Address {...brokerAddress} /> : ''}
          </Box>
        </p>
      </Box>

      <Box flexGrow={1}>
        <Box className="header-binder-policy-main-title">Insured</Box>
        <p>
          <Box className="header-binder-policy-main-subtitle">
            {insuredAlias?.name}
          </Box>
          <Box
            className="header-binder-policy-content"
            style={{ marginBottom: '60px' }}
          >
            {insuredAddress ? <Address {...insuredAddress} /> : ''}
          </Box>
        </p>
      </Box>

      <Stack flexGrow={1} flexDirection={'column'}>
        <Box className="header-binder-policy-main-title">Policy</Box>
        <Stack
          gap={1}
          flexDirection={'row'}
          sx={{
            '@media (max-width: 1400px)': {
              flexDirection: 'column',
            },
            marginTop: '10px',
          }}
        >
          <Box flexGrow={1}>
            <Box className="header-binder-policy-main-subtitle">Limit</Box>
            <Box className="header-binder-policy-content">
              {submissionType === SubmissionType.Primary
                ? quote?.limit
                  ? formatDollarAmount(quote.limit)
                  : 'N/A'
                : quote?.excessConvergeLimit
                ? formatDollarAmount(quote.excessConvergeLimit)
                : 'NA'}
            </Box>
          </Box>
          <Box flexGrow={1}>
            <Box className="header-binder-policy-main-subtitle">
              {submissionType === SubmissionType.Primary
                ? 'Retention'
                : 'Attachment point'}
            </Box>
            <Box className="header-binder-policy-content">
              {submissionType === SubmissionType.Primary
                ? quote?.retention
                  ? formatDollarAmount(quote.retention)
                  : 'N/A'
                : quote?.excessConvergeAttachmentPoint
                ? formatDollarAmount(quote.excessConvergeAttachmentPoint)
                : 'N/A'}
            </Box>
          </Box>
          <Box flexGrow={1}>
            <Box className="header-binder-policy-main-subtitle">Premium</Box>
            <Box className="header-binder-policy-content">
              {submissionType === SubmissionType.Primary
                ? quote?.selectedQuotedPremium ?? quote?.quotedPremium
                  ? formatDollarAmount(
                      quote?.selectedQuotedPremium ?? quote?.quotedPremium ?? 0
                    )
                  : 'N/A'
                : quote?.excessConvergeQuotedPremium
                ? formatDollarAmount(quote.excessConvergeQuotedPremium)
                : 'N/A'}
            </Box>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};
